export default __webpack_public_path__ + "static/media/gamcare.1069bfb2.svg";